import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of, combineLatest } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { AuthService } from 'modules/core/services/auth.service';
import { Selectors, Actions } from '../../../store/root-reducer';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(authService, router, store) {
        this.authService = authService;
        this.router = router;
        this.store = store;
    }
    AuthGuard.prototype.canActivate = function (router, state) {
        var _this = this;
        return this.authService.getUser(true)
            .pipe(switchMap(function () {
            _this.store.dispatch(new Actions.auth.GetUser({ bypassCache: true }));
            return combineLatest([
                _this.store.select(Selectors.billable.getSearchEngines),
                _this.store.select(Selectors.billable.getSubscriptions),
                _this.store.select(Selectors.domain.getCurrentDomain),
                _this.store.select(Selectors.auth.getUserRoles)
            ]);
        }), switchMap(function (_a) {
            var billItem = _a[0], userSubscription = _a[1], domain = _a[2], roles = _a[3];
            if (billItem.length === 0 && userSubscription.length === 0) {
                _this.store.dispatch(new Actions.billable.LoadBillable({ quietUpdate: true }));
            }
            if (roles.length === 0 && domain) {
                _this.store.dispatch(new Actions.auth.GetUserRoles({ domainId: domain.id, currentPath: state.url }));
            }
            if (!domain && state.url.indexOf('select-domain') === -1 && state.url.indexOf('mfa/setup') === -1) {
                _this.router.navigateByUrl('select-domain');
            }
            return of(true);
        }), catchError(function () {
            _this.store.dispatch(new Actions.auth.LogInRequired());
            return of(false);
        }));
    };
    return AuthGuard;
}());
export { AuthGuard };
